module.exports = __webpack_public_path__ + "static/screenshot1-29f19ee0df202445f8f8f62e6a4228fd.png";